module.exports = __webpack_public_path__ + "img/level_logo5.5a67e7d1.png";